module.exports = __webpack_public_path__ + "static/media/MARIACHI LETTER OF INTENT.955ed01f.docx";


//////////////////
// WEBPACK FOOTER
// ./src/files/mariachi/MARIACHI LETTER OF INTENT.docx
// module id = 207
// module chunks = 0